(function () {
  function setUnit(chart, unit) {
    chart.dataset.unit = unit;

    chart.querySelectorAll(".rnt-size-unit").forEach(function (button) {
      button.classList.toggle("is-active", button.dataset.unit === unit);
      button.setAttribute("aria-pressed", button.dataset.unit === unit ? "true" : "false");
    });

    chart.querySelectorAll(".rnt-measure").forEach(function (measure) {
      measure.textContent = measure.dataset[unit] || "";
    });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest(".rnt-size-unit");
    if (!button) return;

    var chart = button.closest(".rnt-size-chart");
    if (!chart) return;

    setUnit(chart, button.dataset.unit || "in");
  });

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".rnt-size-chart").forEach(function (chart) {
      setUnit(chart, chart.dataset.unit || "in");
    });
  });
})();
